export default "__VITE_ASSET__DyxolTFk__"